module.exports = __webpack_public_path__ + "img/body_composition.8ac7c058.svg";